export default "/images/1d31e5e2e11ecf2f233b73a5900afd2e.avif";